import { Pipe, PipeTransform } from '@angular/core';
import { CoreService } from '../../../../lib-components/src/public_api';

@Pipe({
  name: 'localize'
})

export class TranslationPipe implements PipeTransform {

  constructor(
    private indParam: CoreService,
  ) { }

  transform(key: string): string {
    if (key == null) {
      return 'notrad';
    }
    else {
      const vl: string = this.indParam && this.indParam.Trad ? this.indParam.getTrad(key) : '[NULL-TRAD]';
      if (vl)
        return vl;
      else
        return `[${key}]`;
    }
  }
}
